import React from 'react';

export const Icons: Record<string, string> = {
	Announcement: '/announcement.svg',
	FilterList: '/filterList.svg',
	WarningWhite: '/warningwhite.svg',
	Whatsapp: '/whatsapp.svg',
	Instagram: '/instagram.svg',
	Youtube: '/youtube.svg',
	Twitter: '/twitter.svg',
	Facebook: '/facebook.svg',
	CallCalling: '/call-calling.svg',
	elementPlus: '/elementPlus.svg',
	CheckRound: '/checkRoundTick.svg',
	bank: '/bank.svg',
	PenTool: '/penTool.svg',
	Receipt: '/receipt.svg',
	fileExport: '/fileExport.svg',
	TickWhite: '/tickWhite.svg',
	fileCheck: '/fileCheck.svg',
	fileCross: '/fileCross.svg',
	fileUpload: '/fileUpload.svg',
	warningBlack: '/warningBlack.svg',
	fileSubmit: '/fileSubmit.svg',
	fileSubmitRecurr: '/fileSubmitRecurr.svg',
	paymentSuccess: '/paymentSuccess.svg',
	star: '/star.svg',
	complaint: '/complaint.svg',
	tickBlackCircle: '/tickBlackCircle.svg',
};

interface IconComponentProps {
	name: string;
	height?: string;
	width?: string;
	active?: boolean;
}

const Icon: React.FC<IconComponentProps> = ({ name, height = '24', width = '24', ...props }) => {
	const IconAsset = Icons[name];
	if (!IconAsset) return null;
	return (
		<img
			role="presentation"
			aria-hidden="true"
			src={IconAsset}
			height={height}
			width={width}
			alt={name}
			{...props}
		/>
	);
};

export default Icon;
